import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import type { LearnCardDestinationSettings } from "@-/dev.improve.haniverse.lib.learn.destination";
import { useVoiceStudyEnabled } from "@-/dev.improve.haniverse.lib.voice-study";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { useMemo } from "react";

/** The session and device settings the destination resolver branches on. */
export function useLearnCardDestinationSettings(): LearnCardDestinationSettings {
  const [introduceNewCardsEnabled] = useDeviceSetting("introduceNewCardsEnabled");
  const [reviewRechargeNewCardsEnabled] = useDeviceSetting("reviewRechargeNewCardsEnabled");
  const [reviewFocus] = useDeviceSetting("reviewFocus");
  const reviewFocusActive = reviewFocus !== "all";
  const [hasLearnedNewCharacterThisSession] = useContextSelectors(
    NavContext,
    (c) => c.hasLearnedNewCharacterThisSession,
  );
  const voiceActive = useVoiceStudyEnabled();

  return useMemo(
    () => ({
      hasLearnedNewCharacterThisSession,
      introduceNewCardsEnabled,
      reviewFocusActive,
      reviewRechargeNewCardsEnabled,
      voiceActive,
    }),
    [
      hasLearnedNewCharacterThisSession,
      introduceNewCardsEnabled,
      reviewRechargeNewCardsEnabled,
      reviewFocusActive,
      voiceActive,
    ],
  );
}
